import React from "react";
import { Modal } from "antd";
import { ReactComponent as BackIcon } from "../../../assets/svgs/back-button.svg";

export const DailogBox = ({
  open,
  onCancel,
  width = "100%",
  maxWidth = "1200px",
  children
}) => {
  return (
    <Modal
      open={open}
      onCancel={onCancel}
      footer={null}
      width={width}
      closeIcon={<BackIcon style={{ width: "100%", height: "100%" }} />}
      style={{
        maxWidth: maxWidth,
        marginTop: "100px"
      }}
      className="dialogBox"
    >
      {children}
    </Modal>
  );
};
